<div class="astrea-alert-notification d-flex j-c-between a-i-center">
    <p>{{ message }}</p>
    <span (click)="closeNotification()" class="cursor-pointer ml-2">
        <mat-icon aria-label="Cerrar">close</mat-icon>
    </span>
</div>
